__turbopack_context__.v({
  "card": "T9BjfG_card",
  "cta": "T9BjfG_cta",
  "ctaLink": "T9BjfG_ctaLink",
  "description": "T9BjfG_description",
  "descriptionStack": "T9BjfG_descriptionStack",
  "divider": "T9BjfG_divider",
  "featureBody": "T9BjfG_featureBody",
  "featureIntro": "T9BjfG_featureIntro",
  "featureName": "T9BjfG_featureName",
  "featureTitle": "T9BjfG_featureTitle",
  "footer": "T9BjfG_footer",
  "footerBlock": "T9BjfG_footerBlock",
  "header": "T9BjfG_header",
  "headerCopy": "T9BjfG_headerCopy",
  "headerCopySpec": "T9BjfG_headerCopySpec",
  "label": "T9BjfG_label",
  "learnMore": "T9BjfG_learnMore",
  "name": "T9BjfG_name",
  "price": "T9BjfG_price",
  "priceBlock": "T9BjfG_priceBlock",
  "priceLine": "T9BjfG_priceLine",
  "priceRow": "T9BjfG_priceRow",
  "saveBadge": "T9BjfG_saveBadge",
  "saveTag": "T9BjfG_saveTag",
  "specTag": "T9BjfG_specTag",
  "strike": "T9BjfG_strike",
  "thumb": "T9BjfG_thumb",
  "thumbImage": "T9BjfG_thumbImage",
  "top": "T9BjfG_top",
  "visuallyHidden": "T9BjfG_visuallyHidden",
});
